import apiService from './apiService.js';

const resource = '/disciples';

export default {
    getDiscipleTree(locationId) {
        return apiService.get(`${resource}/myDiscipleTree?location_id=${locationId}`);
    },
    getReportingTree(locationId) {
        return apiService.get(`${resource}/my-reporting-tree?location_id=${locationId}`);
    },
    getDiscipleTreeMobile(locationId) {
        return apiService.get(`${resource}/myDiscipleTreeMobile?location_id=${locationId}`);
    },
    getAddableDisciplesList() {
        return apiService.get(`${resource}/listAddableDisciples`);
    },
    getAddableDisciplersList() {
        return apiService.get(`${resource}/listAddableDisciplers`);
    },
    getRemovableDisciplesList() {
        return apiService.get(`${resource}/listRemovableDisciples`);
    },
    getTransferrableDisciplesList() {
        return apiService.get(`${resource}/listTransferrableDisciples`);
    },
    getGrowingAndCommissionedDisciplesList() {
        return apiService.get(`${resource}/listGrowingAndCommissionedDisciples`);
    },
    transferDisciple(disciple, discipler) {
        return apiService.post(`${resource}/transfer`,
            {
                disciple_person_id: disciple,
                new_discipler_person_id: discipler
            });
    },
    addDisciple(disciple, discipler, discipleType) {
        return apiService.post(`${resource}`,
            {
                disciple_person_id: disciple,
                discipler_person_id: discipler,
                disciple_type: discipleType
            });
    },
    endDisciple(disciple, reason) {
        return apiService.put(`${resource}/end/${disciple}`,
            {
                ended_reason: reason
            });
    },
    updateDiscipleType(disciplePersonId, discipleType) {
        return apiService.put(`${resource}`,
            {
                // Person id of the discipleship record
                disciple_person_id: disciplePersonId,
                // String matching exactly 'Growing Disciple' or 'Commissioned Disciple'
                disciple_type: discipleType
            });
    },
    // getPost(postId)
    //     return apiService.get(`${resource}/${postId}`);
    // },

    // createPost(payload) {
    //     return apiService.post(`${resource}`, payload);
    // }
};
